import { defineComponent as _defineComponent } from 'vue'
import AlertsTab from '@/components/careConsole/Alerts.vue';
import CuttingHeadTab from '@/components/careConsole/CuttingHead.vue';
import HealthTab from '@/components/careConsole/Health.vue';
import LaserConsumptionTab from '@/components/careConsole/LaserConsumption.vue';
import EventsTab from '@/components/careConsole/Events.vue';
import OverviewTab from '@/components/careConsole/Overview.vue';
import { CareTab } from './commons/navigation';
import { Device } from '@/models/device';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { ImportantMessageLevel } from '@/models/Charts/chartsData';
import { useI18n } from '@/composables/i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CareConsoleMainView',
  props: {
    activeTab: null,
    selectedDeviceId: null,
    dateRangeSelection: null,
    selectedTimeAxisSpan: null,
    selectedEventTypes: null,
    selectedEventModules: null,
    selectedEventCodes: null,
    devices: null
  },
  emits: ["change:tab"],
  setup(__props: any, { emit }: { emit: ((e: 'change:tab', index: number) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  activeTab: CareTab;
  selectedDeviceId: string;
  dateRangeSelection: [Date, Date];
  selectedTimeAxisSpan: FilterTimeAxisSpanEnum;
  selectedEventTypes: ImportantMessageLevel[];
  selectedEventModules: string[];
  selectedEventCodes: string[];
  devices: Device[];
};





const { t } = useI18n();

const selectedDevice = computed<Device>(
  () =>
    props.devices.find((device) => device.deviceId === props.selectedDeviceId)!,
);

return { __sfc: true,props, emit, t, selectedDevice, AlertsTab, CuttingHeadTab, HealthTab, LaserConsumptionTab, EventsTab, OverviewTab, CareTab }
}

})